import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { fetchAndCacheCountry } from "./utils/geo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Fetch and cache visitor country on initial page load (non-blocking)
// cached value is returned immediately if present and fresh (<30 days)
fetchAndCacheCountry().then((country) => {
  if (country) {
    // expose for analytics or later reads
    try {
      window.__RXO_GEO_COUNTRY = country;
    } catch (e) {}
  }
});

